export function getBmwSerial(vin) {
  if (!vin) return '';
  return vin.slice(-7);
}
export function kwToHp(kw) {
  return Math.round(kw * 1.3596216173);
}